<template>
  <div>
    <div class="input-group img-group">
      <div class="text-center dropzone logo">
        <input class="upload-file img-file-m" type="file" ref="file" accept="image/*" @change="handleFileUpload()" />
        <input class="upload-file img-file-m" name="logo0" style="z-index: 0" />
        <div class="addImage" v-if="!showImageUrl" style="width: 100%">
          <a class="addImageIcon btn btn-primary btn-circle">
            <i class="el-icon-upload2"></i>
          </a>
          <p class="m-t-sm font14 suggestFont">
            <slot name="sizeHint"></slot>
          </p>
        </div>
        <div class="editImage" v-if="showImageUrl">
          <div class="mask-bg"></div>
          <img style="width: 100%;" :src="this.image + showImageUrl" />
          <div class="icon-center">
            <span class="edit-icon">
              <i class="el-icon-edit"></i>
            </span>
            <p class="font-white m-t-sm font14 suggestFont">
              <slot name="sizeHint"></slot>
            </p>
          </div>
        </div>
      </div>
    </div>
    <slot name="sizeError" v-if="haveSizeError">{{ $t("message.Image size error") }}</slot>
    <slot name="dimensionError" v-if="haveDimensionError">{{ $t("message.Dimension Error") }}</slot>
    <slot name="UploadError" v-if="haveUploadError">Upload Failed!</slot>
  </div>
</template>
<script>
import axios from "axios";
import store from "../../store";
import config from "../../config";

export default {
  name: "file-upload",
  mixins: [config.globalMixin],
  components: {},
  data() {
    return {
      //showImageUrl: ""
      haveSizeError: false,
      haveDimensionError: false,
      haveUploadError: false,
    };
  },
  props: {
    value: String,
    image: { type: String, default: "" },
    modifyLabel: { type: String, default: "Modify" },
    type: { type: String, default: "" },
    sizeHints: { type: String, default: "" },
    filewidth: { type: Number, default: 0 },
    fileheight: { type: Number, default: 0 },
    limit: { type: Number, default: 0 },
    callback: null,
    item: {},
  },
  computed: {
    showImageUrl() {
      return this.$props.value;
    },
    showSizeHint() {
      if (this.$props.sizeHint) {
        return this.$props.sizeHints;
      }
      return `${this.$props.filewidth} x ${this.$props.fileheight}, Max ${this.$props.limit} MB.`;
    },
  },
  methods: {
    _checkFilesize(file) {
      let size = file.size;

      if (size <= this.$props.limit * 1000 * 1000) {
        return true;
      }
      return false;
    },
    async _checkImagesize(file) {
      if (this.$props.filewidth != null && this.$props.fileheight != null) {
        if (this.$props.filewidth === 0 && this.$props.fileheight === 0) {
          return false;
        }
        if (file) {
          let imgsize = await new Promise((resolve, reject) => {
            let img = new Image();
            img.onload = () => {
              window.URL.revokeObjectURL(img.src);
              resolve({ height: img.height, width: img.width });
            };
            img.onerror = reject;
            img.src = window.URL.createObjectURL(file);
          });

          let width = imgsize.width,
            height = imgsize.height;
          if ((width !== this.$props.filewidth || height !== this.$props.fileheight) && width / height !== this.$props.filewidth / this.$props.fileheight) {
            return false;
          } else {
            //fail
            return true;
          }
        }
        return false;
      } else return true;
    },
    async handleFileUpload() {
      this.haveSizeError = false;
      this.haveDimensionError = false;
      this.haveUploadError = false;
      this.file = this.$refs.file.files[0];
      if (!(await this._checkImagesize(this.file))) {
        this.haveDimensionError = true;
        return false;
      }
      // if (
      //   this.$props.filewidth &&
      //   this.$props.fileheight &&
      //   !(await this._checkImagesize(this.file))
      // ) {
      //   this.haveDimensionError = true;
      //   return false;
      // }
      if (!this._checkFilesize(this.file)) {
        this.haveSizeError = true;
        return false;
      }

      let formData = new FormData();

      /*
                Add the form data we need to submit
            */
      var newName = this.file.name.replaceAll(/\s+/g, "_");
      formData.append("file", this.file, newName);
      // formData.append("token", store.state.userInfo.token);
      // formData.append("userId", store.state.userInfo.userId);
      // formData.append('lang', "en_US")

      /*
          Make the request to the POST /single-file URL
        */
      var that = this;
      axios
        .post(this.fileUploadUrl, formData, {
          headers: {
            Authorization: `${this.$store.state.userInfo.token}`,
          },
          params: {
            type: this.type,
          },
        })
        .then(data => {
          if (data.data.errorCode === "0000") {
            this.$emit("input", data.data.result.fileName);
            //this.value = data.data.result.url;  qa3
            if (this.callback) this.callback(data.data.result, this.item);
          } else {
            this.$store.commit("setwarning", {
              string: data.data.status_message,
              boolean: true,
              button: [
                {
                  name: "Cancel",
                  callBack: function() {
                    that.$store.commit("setwarning", {
                      string: "",
                      boolean: false,
                    });
                  },
                },
              ],
            });
            resolve(false);
          }
          this.$refs.file.value = "";
        })
        .catch(() => {
          this.$refs.file.value = "";
          this.haveUploadError = true;
        });
    },
  },
  mounted() {},
  created() {},
};
</script>
